import useKSDocumentExplorerViewModel from './KSDocumentExplorerViewModel'

//cd9ef5d8-91fb-4ebd-9740-58798b9f264a

// NOTE: WIP

const KSDocumentExplorer = () => {
    
    const vm = useKSDocumentExplorerViewModel()
    
    return (
        
        <div className="KSDocumentExplorer">
            
            <header className="flex items-center gap-4">
                <button
                    className="btn"
                    onClick={vm.loadDocument}>
                    LOAD DOCUMENT
                </button>
                <input
                    className="input input-bordered w-full"
                    type="text"
                    value={vm.documentId}
                    placeholder="Document ID"
                    onChange={e => vm.setDocumentId(e.target.value)} />
            </header>
            
            {vm.error && (
                <div className="text-red-500">{vm.error}</div>
            )}
            
            {vm.loading && (
                <div className="flex justify-center p-4 text-center">
                    <div className="loading loading-spinner"/>
                </div>
            )}
            
            {!vm.error && !vm.loading && vm.document && (
                <div className="flex flex-wrap gap-2 mt-4">
                    
                    <div className="">
                        <h5 className="text-xl">{vm.document.name}</h5>
                        <table className="table table-auto table-xs table-zebra w-full">
                            <tbody>
                                {Object.keys(vm.document).map(it => (
                                    <tr key={it}>
                                        <th>{it}</th>
                                        <td>{vm.document[it]?.toString() || '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    
                    <div className="">
                        <h5>Document Pages</h5>
                        <div className="grid grid-cols-auto gap-4">
                            {vm.document.pages?.map(it => (
                                <div key={it.id}>
                                    <div>{it.fileName}</div>
                                    <img
                                        className="w-full max-w-[150px]"
                                        src={vm.pageUrls[it.id]} />
                                </div>
                            ))}
                        </div>
                    </div>
                
                </div>
            )}
        
        </div>
        
    )
    
}

export default KSDocumentExplorer
